let React = require("react");

let Toast = require("../../Toast.jsx");

class MemberRemoved extends React.Component {

    constructor(){
        super();

        this.whatMeans = this.whatMeans.bind(this)
    }

    whatMeans(){
        this.props.setConfirmation(true, `Member Removed`,
                                                `You have been removed as a member from <span class="bold">${this.props.hubName}</span>.
                                                As a result, you will no longer be able to edit or access content from this ${fullHubAlias}.
                                                Any questions or concerns should be directed to the ${hubAlias} administrator.`,
                                        () => {
                                            this.props.onClose("memberRemoved");
                                        },
                                    null, null, null, false)
    }


    render() {
        const {show, hubName, onClose, resizeToastContainer} = this.props;

        return  <Toast show={show} resizeToastContainer={resizeToastContainer} onClose={() => onClose("memberRemoved")} type="warning" toastName="isMember">
                    <p className="text">You have been removed from "{hubName}" <a href="#" onClick={this.whatMeans}>What this means</a></p>
                </Toast>
    }
}

module.exports = MemberRemoved;
